import React from "react";
import "./WitEarnHome.scss"
import ReviewCard from "../../components/ReviewCard/ReviewCard";
import { sortByOrderAscending } from "../../helper/helper";

const WitEarnHomeReviews = ({ components }) => {
    const getComponents = (key, component) => {
        switch (component.ID) {
            case "HeaderText":
                return <div className="WitEarnHomeReviews-header">
                    {component?.Props?.text}
                </div>
            case "HeaderSubText":
                return <div className="WitEarnHomeReviews-subheader">
                    {component?.Props?.text}
                </div>
            case "WitEarnHomeReviewsComponent":
                return <div className="WitEarnHomeReviews-grid">
                    {component?.Data?.map((review, index) => {
                        return (
                            <ReviewCard review={review} key={index} />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="WitEarnHomeReviews">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponents(key, component)

            })}
        </div>
    )
}
export default WitEarnHomeReviews